// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import service from './services';
import store from './store';
import HcLink from '@/components/common/hc-link';
import Loading from '@/components/common/loading';
import toast from '@/components/common/toast';
import TopBar from '@/components/top-bar';
import report from '@/utils/report';
import { firebase } from '@/utils/report';
import youTube from '@/lib/you-tube';
import { translateCrowd } from '@/utils/index';


const eventBus = new Vue();

Vue.component('hc-link', HcLink);
Vue.component('page-loading', Loading);
Vue.component('top-bar', TopBar);

Vue.filter('crowd', translateCrowd);

Vue.prototype.$toast = toast;
Vue.prototype.$report = report; // 既上报客户端埋点，又上报firebase
Vue.prototype.$firebase = firebase; // 只上报firebase
Vue.config.productionTip = false;
Vue.prototype.$service = service;
Vue.prototype.$eventBus = eventBus;
Vue.prototype.$youTube = youTube;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js